import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=335f8a0c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335f8a0c')) {
      api.createRecord('335f8a0c', component.options)
    } else {
      api.reload('335f8a0c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=335f8a0c&", function () {
      api.rerender('335f8a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yB17zVejxfka/JS/imageCarousel.vue"
export default component.exports